import { Inscription } from './../classes/inscription';
import { Injectable } from "@angular/core";
import { Http, Headers, RequestOptions, Response, URLSearchParams } from "@angular/http";
import { Observable } from "rxjs";
import "rxjs/add/operator/map";
import { EbUser } from "../classes/user";
import { EbEtablissement } from "../classes/etablissement";
import { EbCompagnie } from "../classes/compagnie";
import { EbAdresse } from "../classes/adresse";
import { SearchCriteria } from "../utils/searchCriteria";
import { Statique } from "../utils/statique";

@Injectable()
export class InscriptionService {

  Statique = Statique;
  constructor(private http: Http) {}

  inscription(inscription: Inscription) {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let body = JSON.stringify(inscription);
    console.log(body);
    return this.http
      .post(Statique.controllerInscription + "", body, {
        headers: headers
      })
      .map((res: Response) => res.json());
  }

  listPays() {
    return this.http
      .get(Statique.controllerStatiqueListe + "/countries")
      .map((res: Response) => res.json());
  }

  // listVille() {
  //   return this.http.get("/api/list/cities")
  //   .map((res: Response) => res.json());
  // }

  getCompagnieBySiren(siren: string){
    let params = new URLSearchParams();
    params.set("siren", siren);
    return this.http.get(Statique.controllerInscription + "/getCompagnie", {search: params })
    .map((res: Response) => res.json())
    ;
  }

  getEtablissementBySiret(siret: string){
    let params = new URLSearchParams();
    params.set("siret", siret);
    return this.http.get(Statique.controllerInscription + "/getEtablissement", {search: params })
    .map((res: Response) => res.json());
  }

  activerCompte(activeToken: string) {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    return this.http.post(Statique.controllerInscription + "/activate-account", activeToken, {
      headers: headers
    }).map(res => res.json());
}

  checkEmail(email: string){
    let params = new URLSearchParams();
    params.set("email", email);
    return this.http.post(Statique.controllerInscription + "/emailExist", email)
    .map((res: Response) => res.json());
  }

  saveUser(ebUser: EbUser) {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let body = JSON.stringify(ebUser);
    
    return this.http
      .post(Statique.controllerInscription + "/save-user", body, {
        headers: headers
      })
      .map((res: Response) => res.json());
  }


}



// WEBPACK FOOTER //
// ./src/app/services/inscription.service.ts